import $ from 'jquery';

const $archives = $( '.js-archive' );
$archives.each( function () {
	const $archive = $( this );
	const $row = $archive.find( '.js-archive__row' );
	const $loadMoreBtn = $archive.find( '.js-archive__load-more-btn' );
	let xhr;

	const shiftIndex = $archive.data( 'shift-index' ) || 0;
	const postType = $archive.data( 'post-type' ) || 'post';

	$loadMoreBtn.on( 'click', function ( e ) {
		e.preventDefault();

		if ( xhr ) {
			// ajax request already in progress
			return;
		}

		const currentPage = $archive.data( 'current-page' ) || 1;
		// $loadMoreBtn.addClass( 'c-link-load--disabled' );

		xhr = $.ajax( {
			url: window.designstudio.ajaxUrl,
			data: {
				action: 'designstudio_archive_load_more',
				designstudio_load_page: currentPage + 1,
				designstudio_index_shift: shiftIndex,
				designstudio_posts_per_page: window.designstudio.blogPostsPerPage,
				designstudio_post_type: postType
			},
			dataType: 'json',
			success: function( data ) {
				$archive.data( 'current-page', data.page );
				$( data.data ).hide().appendTo( $row ).fadeIn();

				if ( ( data.page + 1 ) < Math.ceil( data.found_posts / window.designstudio.blogPostsPerPage ) ) {
					// has more results
				} else {
					// no more results
					$loadMoreBtn.css( 'display', 'none' );
				}
			},
			error: function() {
				// console.log( 'error' );
			},
			complete: function () {
				// $loadMoreBtn.removeClass( 'c-link-load--disabled' );
				xhr = undefined;
			}
		} );
	} );
} );
